import React from 'react'
import { component_tool } from '@/tool'
const { WizComponent, WizCard, WizRow, WizCol, WizTypography } = component_tool
const { Text } = WizTypography
import './index.less'

class CounselingHeader extends WizComponent {

    componentName = 'CounselingHeader'

    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        let { record = {} } = this.props
        let { orgName, brandName, onlineTime, preSalesNumber, afterSalesNumber, moduleType } = record
        return (
            <WizCard className='counseling-info' title='经销商信息'>
                <WizRow className='info-row'>
                    <WizCol className='info-col' span={9}>
                        <Text strong>{'经销商名称：'} {orgName}</Text>
                    </WizCol>
                    <WizCol className='info-col' span={8}>
                        <Text strong>{'品牌：'} {brandName}</Text>
                    </WizCol>
                    <WizCol className='info-col' span={7}>
                        <Text strong>{'上线日期：'} {onlineTime}</Text>
                    </WizCol>
                </WizRow>
                <WizRow className='info-row'>
                    <WizCol className='info-col' span={9}>
                        <Text strong>{'销售代码：'} {preSalesNumber}</Text>
                    </WizCol>
                    <WizCol className='info-col' span={8}>
                        <Text strong>{'售后代码：'} {afterSalesNumber}</Text>
                    </WizCol>
                    <WizCol className='info-col' span={7}>
                        <Text strong>{'辅导模块：'} {moduleType === 0 ? '销售' : '售后'}</Text>
                    </WizCol>
                </WizRow>
            </WizCard>
        )
    }
}

export default CounselingHeader


